<template>
        <div v-if="this.loading">
            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
        </div>
        <div v-else>
            <div v-if="this.authorisesUser">
                <agency-dashboard v-if="me && me.company_type == 'agency'"  :me="me" />
                <business-dashboard v-if="me.company_type == 'business'"  :me="me" />
            </div>
            <div v-else>
                <template>
                    <v-container class="d-flex align-center justify-center" style="height: 100vh;">
                        <v-card class="pa-5 text-center" elevation="3" max-width="400">
                            <v-icon size="64" color="red darken-2">mdi-lock</v-icon>
                            <v-card-title class="text-h6 font-weight-bold mt-2">
                                You are not authorized to view this page
                            </v-card-title>
                            <v-card-text class="text-grey-darken-1">
                                Please contact the administrator if you believe this is a mistake.
                            </v-card-text>
                            <v-btn color="primary" outlined class="mt-3" @click="$router.push('/')">
                                <v-icon left>mdi-home</v-icon> Go to Home
                            </v-btn>
                        </v-card>
                    </v-container>
                </template>
            </div>
        </div>
  </template>
  
  <script>
    import axios from 'axios'
    import { mapState } from 'vuex'
    import BusinessDashboard from '@/views/landing/BusinessGHLReport.vue'
    import AgencyDashboard from '@/views/landing/AgencyGHLReport.vue'
  export default {
    metaInfo () {
        return {
        title: "Dashboard | " + this.$appName
        }
    },
    components: {
        BusinessDashboard,
        AgencyDashboard
    },
    data() {
        return{
            postVisible:'',
            respondVisible:'',
            apiKey:'',
            authorisesUser:false,
            me:'',
            loading:false,
        };
    },
    methods:{
       async assignments(){
            this.loading = true;
            this.postVisible = this.$route.query.post;  
            this.respondVisible = this.$route.query.respond;  
            this.apiKey = this.$route.params.apiKey;  
            if (!this.postVisible || !this.respondVisible || !this.apiKey) {
                this.loading = false;
                return
            } 

            let response  = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/verify-user`,{
                ghl_key:this.apiKey,
            });
            if(response.data.status == 'success'){
                this.authorisesUser = true;
                this.me =response.data.user;
            }else{
                this.authorisesUser = false;
                // this.$store.commit('auth/login', response.data.token);
            }
            this.loading = false;
        },
    },
    mounted() {
      this.assignments();
    }
  };
  </script>
  